export const userNamePattern = "[A-zÀ-ÿ0-9 ]+";

export const emailPattern =
  "^[a-z0-9][a-z0-9._%+-]{0,63}@(?:(?=[a-z0-9-]{1,63}\\.)[a-z0-9]+(?:-[a-z0-9]+)*\\.){1,8}[a-z]{2,63}$";

const passwordMinimumLength = 8;

export const checkEmailFormat = (email: string | undefined): Promise<string> => {
  return new Promise((resolve, reject) => {
    if (!email) {
      reject("CFE-006");
    } else if (new RegExp(emailPattern).test(email)) {
      resolve(email);
    } else {
      reject("CFE-007");
    }
  });
};

export const checkPasswordFormat = (password: string): Promise<string> => {
  return new Promise((resolve, reject) => {
    if (password.length >= passwordMinimumLength) {
      resolve(password);
    } else {
      reject("CFE-008");
    }
  });
};
